// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { headerWarehouseInformationStyle } from "@pace/App/Widgets/Common/HeaderWarehouseInformation";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

headerWarehouseInformationStyle.wrapper = {
    css: css`
        display: flex;
        ${({ direction }: any) => (direction === "column" ? `flex-direction: column; gap:12px` : `gap: 16px;`)}
        ${xScreen(1024, 1330)} {
            ${({ isCheckoutPage }: any) => (
                !isCheckoutPage && `
                    flex-direction: column;
                    gap: 0;
                `
            )}
        }
        ${xScreen("lte", "md")} {
            ${({ isCheckoutPage }: any) => (
                isCheckoutPage && `
                    width: 100%;
                `
            )}
        }
        ${xScreen("lte", "xs")} {
            ${({ isCheckoutPage }: any) => (
                isCheckoutPage && `
                    flex-direction: column;
                    gap: 8px;
                `
            )}
        }
    `,
};
headerWarehouseInformationStyle.sectionWrapper = {
    css: css`
        display: flex;
    `,
};
headerWarehouseInformationStyle.label = {
    size: 12,
    css: css`
        && {
            line-height: 17px;
            margin-right: 4px;
        }
    `,
};
headerWarehouseInformationStyle.link = {
    typographyProps: {
        size: 12,
        lineHeight: "13px",
        css: css`
            && {
                font-weight: ${fontConfig.weight.bold};
            }
        `,
    },
};
